import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

//TYPES
import {
  UpdatePersonalInfoPayload,
  UpdateEmploymentDetailsPayload,
  UpdateAddressPayload,
} from "../Types/Employee/EmployeeModel";

export const EMPLOYEE_QUERY_KEY = ["employee"];
export const VIEW_EMPLOYEE_QUERY_KEY = ["view-employee"];
export const VIEW_EMPLOYEE_PROFILE_QUERY_KEY = ["view-employee-profile"];

export const employeeService = {
  uploadProfile: async (application_no: string, payload: FormData) => {
    return api.post(
      `api/employees/${application_no}/profile-picture`,
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  },

  updatePersonalInfo: async (
    emp_no: string,
    payload: UpdatePersonalInfoPayload,
  ) => {
    const response = await api.patch(`api/employees/${emp_no}`, payload);
    return response.data;
  },

  updateEmpDetails: async (
    emp_no: string,
    payload: UpdateEmploymentDetailsPayload,
  ) => {
    const response = await api.patch(`api/employees/${emp_no}`, payload);
    return response.data;
  },

  updateAddress: async (
    application_no: string,
    payload: UpdateAddressPayload,
  ) => {
    const response = await api.patch(
      `api/employees/${application_no}`,
      payload,
    );
    return response.data;
  },

  getAllEmployee: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/employees`, { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),

  getEmployeeById: async (emp_no: string) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/employees/${emp_no}`);
      return response.data;
    });
  },

  viewAllEmployeeProfile: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-employee-profile`, { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),

  viewEmployeeProfileByEmpno: async (emp_no: string) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/view-employee-profile/${emp_no}`);
      return response.data;
    });
  },

  viewEmploymentByEmpno: async (emp_no: string) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/view-employee/${emp_no}`);
      return response.data;
    });
  },
};
